module.exports = __webpack_public_path__ + "static/media/makeup.e5b8e9b1.svg";